
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

import { ReviewsActions, FacebookActions } from '@actions/index'
import * as fromReviews from '@reducers/index'
import { Observable } from 'rxjs';
import { ReviewModel, RequestModel, FilterReviewModel, ReviewRequestFilteredPaginatedModel, ReviewTargetModel } from '@models/index';

@Injectable({
    providedIn: 'root'
})
export class ReviewsFacadeService {

    constructor(private store: Store<any>, public router: Router,) { }

    clearState$() {
        this.store.dispatch(FacebookActions.clearState());
    }

    getReviewsByLocation$(): Observable<ReviewModel[]> {
        return this.store.select(fromReviews.getReviews)
    }

    getPagesId$(): Observable<{ page: number, startKey: string, startDatePosted: number, locationId?: string }[]> {
        return this.store.select(fromReviews.getPagesId)
    }

    getReviewsTotal$(): Observable<number> {
        return this.store.select(fromReviews.getTotalReviews)
    }

    getReviewsFilterTotal$(): Observable<number> {
        return this.store.select(fromReviews.getFilterTotalReviews)
    }

    getReviewsError$(): Observable<string> {
        return this.store.select(fromReviews.getErrorReviews)
    }

    searchReviewsByLocation(payload: { startKey: string, startDatePosted: number, size: number }) {
        const request: RequestModel = {
            params: `reviews?startKey=${payload.startKey}&startDatePosted=${payload.startDatePosted}&size=${payload.size}`,
        }
        this.store.dispatch(ReviewsActions.searchReviewsByLocation({ request }))
    }
    getReplyToDelete$(): Observable<string> {
        return this.store.select(fromReviews.getReplyToDelete)
    }

    getReplyToBePosted$(): Observable<{ reviewId: string, reply: string }> {
        return this.store.select(fromReviews.getReplyToBePosted)
    }

    searchReviewsByLocationId(payload: { startKey: string, startDatePosted: number, size: number, locationId: string }) {
        const request: RequestModel = {
            params: `reviews?startKey=${payload.startKey}&startDatePosted=${payload.startDatePosted}&size=${payload.size}&locationId=${payload.locationId}`,
        }
        this.store.dispatch(ReviewsActions.searchReviewsByLocationId({ request }))
    }

    getTotalReviewsByLocation() {
        const request: RequestModel = {
            params: `reviews/count?`,
        }
        this.store.dispatch(ReviewsActions.getTotalReviewsByLocation({ request }))
    }

    searchPagesId(payload: { reviewRequestFiltered: ReviewRequestFilteredPaginatedModel }) {
        const request: RequestModel = {
            params: `reviews/review-ids-paginated-location`,
            payload: payload.reviewRequestFiltered
        }
        this.store.dispatch(ReviewsActions.getPagesId({ request }))
    }

    searchPagesIdByBusiness(payload: { reviewRequestFiltered: ReviewRequestFilteredPaginatedModel }) {
        const request: RequestModel = {
            params: `reviews/review-ids-paginated-business`,
            payload: payload.reviewRequestFiltered
        }
        this.store.dispatch(ReviewsActions.getPagesId({ request }))
    }

    filterReviewsByLocation(payload: { startKey: string, startDatePosted: number, size: number, filter: FilterReviewModel }) {
        const request: RequestModel = {
            params: `reviews/filter?startKey=${payload.startKey}&startDatePosted=${payload.startDatePosted}&size=${payload.size}`,
            payload: payload.filter
        }
        this.store.dispatch(ReviewsActions.filterReviewsByLocation({ request }))
    }

    filterReviewsByLocationId(payload: { startKey: string, startDatePosted: number, size: number, filter: FilterReviewModel, locationId: string }) {
        const request: RequestModel = {
            params: `reviews/filter?startKey=${payload.startKey}&startDatePosted=${payload.startDatePosted}&size=${payload.size}&locationId=${payload.locationId}`,
            payload: payload.filter
        }
        this.store.dispatch(ReviewsActions.filterReviewsByLocationId({ request }))
    }

    getAllReviews(payload: { startKey: string, startDatePosted: number, businessId: string, size: number, startTime: number, endTime: number, locationId: string }) {
        const request: RequestModel = {
            params: `reviews/business?businessId=${payload.businessId}&startKey=${payload.startKey}&startDatePosted=${payload.startDatePosted}&size=${payload.size}&startTime=${payload.startTime}&endTime=${payload.endTime}&locationId=${payload.locationId}`,
        }
        this.store.dispatch(ReviewsActions.getAllReviews({ request }))
    }
    deleteReviewReply(payload: { reviewId: string, locationId: string }) {
        const request: RequestModel = {
            params: `reviews/reply/delete/${payload.reviewId}?locationId=${payload.locationId}`,

        }
        this.store.dispatch(ReviewsActions.deleteReviewReply({ request }))
    }

    replyToReview(payload: { reviewId: string, locationId: string, reply: string }) {
        const request: RequestModel = {
            params: `reviews/reply/${payload.reviewId}?locationId=${payload.locationId}`,
            payload: payload.reply
        }

        this.store.dispatch(ReviewsActions.replyToReview({ request }))
    }

    generateReplyResponse(
        payload: {
            locationId: string,
            reviewerName: string,
            reviewMessage: string,
            locationName: string,
            reviewSite: string,
            startRating: number,
        }) {
        const request: RequestModel = {
            params: `reviews/reply-generate-response`,
            payload
        }

        this.store.dispatch(ReviewsActions.generateReplyResponse({ request }))
    }
    markReviewSpam(payload: {locationId: string, messageHash: string, isSpam: boolean}) {
        const request: RequestModel = {
            params:`reviews/spam`,
            payload: {
                locationId: payload.locationId,
                messageHash: payload.messageHash,
                isSpam: payload.isSpam
            }
        }

        this.store.dispatch(ReviewsActions.markReviewSpam({ request }))
    }


    addOnOpenAi(payload: {reselerId: string, businessId: string, locationId: string, userId: string}){
        const request: RequestModel = {
            params: `reviews/add-on?resellerId=${payload.reselerId}&businessId=${payload.businessId}&locationId=${payload.locationId}&userId=${payload.userId}`,
            payload
        }
        this.store.dispatch(ReviewsActions.replyIntegration({request}))
    }
}
// `reviews/business?businessId=${}&page=${payload.page}&size=${payload.size}&startTime=${payload.locationId}&endTime=${payload.locationId}`,
